(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accordion-section"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-accordion-section]').forEach((sectionRoot) => {
    const accordion = sectionRoot.querySelector('[data-as-accordion]');
    const availabilityMapEl = sectionRoot.querySelector('[data-variant-availability]');
    const orderStatusNoteRow = sectionRoot.querySelector('[data-order-status-note-row]');
    const orderStatusNoteDisplay = sectionRoot.querySelector('[data-order-status-note]');
    const availabilityDot = sectionRoot.querySelector('[data-availability-dot]');
    const flavorHighlightColors = {
      all: '#77bf8f',
      'Lemon Fresh': '#77BF8E',
      'Fresh Pineapple': '#F3CD2E',
      'Superstrong Sour Ginger': '#CC0000',
      'Sour Ginger': '#22573F',
    };

    let variantAvailabilityMap = {};

    if (availabilityMapEl) {
      try {
        variantAvailabilityMap = JSON.parse(availabilityMapEl.textContent || '{}');
      } catch (_) {
        variantAvailabilityMap = {};
      }
    }

    const setHighlightColor = (flavor) => {
      const color = flavorHighlightColors[flavor] || flavorHighlightColors.all;
      sectionRoot.style.setProperty('--accordion-section-highlight', color);
    };

    const normalizeVariantId = (value) => {
      if (value === null || typeof value === 'undefined') return '';
      const raw = String(value).trim();
      if (!raw) return '';
      const digitMatch = raw.match(/\d+/g);
      if (digitMatch && digitMatch.length) {
        return digitMatch[digitMatch.length - 1];
      }
      return raw;
    };

    const applyVariantAvailability = (variantId) => {
      if (!variantId || !availabilityMapEl || !orderStatusNoteRow) return;

      const key = normalizeVariantId(variantId);
      const availability = variantAvailabilityMap[key];

      if (typeof availability === 'undefined') return;

      const note = (typeof availability === 'object' ? availability.order_status_note : null) || '';
      if (orderStatusNoteDisplay) orderStatusNoteDisplay.textContent = note;
      if (note) {
        orderStatusNoteRow.removeAttribute('hidden');
      } else {
        orderStatusNoteRow.setAttribute('hidden', 'hidden');
      }

      if (availabilityDot && typeof availability === 'object') {
        const isPreorder = availability.preorder === true;
        const isAvailable = availability.available === true;
        const inventoryQuantity =
          typeof availability.inventory_quantity === 'number' ? availability.inventory_quantity : 1;
        const isOutOfStock = !isAvailable || inventoryQuantity <= 0;
        availabilityDot.classList.remove(
          'accordion-section__availability-dot--out',
          'accordion-section__availability-dot--preorder'
        );
        if (isPreorder) {
          availabilityDot.classList.add('accordion-section__availability-dot--preorder');
        } else if (isOutOfStock) {
          availabilityDot.classList.add('accordion-section__availability-dot--out');
        }
      }
    };

    document.addEventListener('shop:product-change', (event) => {
      const detail = event.detail || {};
      const variantId = detail.variantId;

      applyVariantAvailability(variantId);
    });

    document.addEventListener('change', (event) => {
      const target = event.target;
      if (!(target instanceof HTMLSelectElement)) return;
      if (!target.matches('[data-shop-sticky-cta-variant-select]')) return;
      applyVariantAvailability(target.value);
    });

    document.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      const headerButton = target.closest('[data-shop-header-button][data-variant-id]');
      if (!headerButton) return;
      applyVariantAvailability(headerButton.getAttribute('data-variant-id'));
    });

    const initialVariantId = window.__shopSelection?.variantId || sectionRoot.dataset.initialVariantId || '';
    applyVariantAvailability(initialVariantId);

    if (!accordion) {
      return;
    }

    const desktopQuery = window.matchMedia('(min-width: 750px)');
    const leftColumn = sectionRoot.querySelector('.accordion-section__left');
    const rightColumn = sectionRoot.querySelector('.accordion-section__right');
    const items = Array.from(accordion.querySelectorAll('[data-as-item]'));

    const syncAccordionHeight = () => {
      if (!leftColumn || !rightColumn) {
        return;
      }

      if (!desktopQuery.matches) {
        sectionRoot.style.removeProperty('--accordion-right-row-height');
        sectionRoot.style.removeProperty('--accordion-right-max-height');
        sectionRoot.style.removeProperty('--accordion-panel-max-height');
        return;
      }

      const leftHeight = Math.ceil(leftColumn.getBoundingClientRect().height);
      const minRowHeightFromCss = parseInt(
        getComputedStyle(sectionRoot).getPropertyValue('--accordion-desktop-min-row-height'),
        10
      );
      const desktopMinRowHeight = Number.isFinite(minRowHeightFromCss) ? minRowHeightFromCss : 520;
      const rowHeight = Math.max(leftHeight, desktopMinRowHeight);
      const totalTriggerHeight = items.reduce((sum, item) => {
        const trigger = item.querySelector('[data-as-trigger]');
        return sum + (trigger ? trigger.getBoundingClientRect().height : 0);
      }, 0);

      const panelMaxHeight = Math.max(80, Math.floor(rowHeight - totalTriggerHeight - 24));

      sectionRoot.style.setProperty('--accordion-right-row-height', `${rowHeight}px`);
      sectionRoot.style.setProperty('--accordion-right-max-height', `${rowHeight}px`);
      sectionRoot.style.setProperty('--accordion-panel-max-height', `${panelMaxHeight}px`);
    };

    if (typeof ResizeObserver === 'function' && leftColumn) {
      const leftColumnObserver = new ResizeObserver(() => {
        syncAccordionHeight();
      });
      leftColumnObserver.observe(leftColumn);
    }

    if (desktopQuery.addEventListener) {
      desktopQuery.addEventListener('change', syncAccordionHeight);
    } else if (desktopQuery.addListener) {
      desktopQuery.addListener(syncAccordionHeight);
    }

    window.addEventListener('resize', syncAccordionHeight);
    syncAccordionHeight();

    const closeItem = (accordionItem) => {
      accordionItem.classList.remove('is-open');
      const accordionTrigger = accordionItem.querySelector('[data-as-trigger]');
      if (accordionTrigger) {
        accordionTrigger.setAttribute('aria-expanded', 'false');
      }
    };

    const openItem = (accordionItem) => {
      accordionItem.classList.add('is-open');
      const accordionTrigger = accordionItem.querySelector('[data-as-trigger]');
      if (accordionTrigger) {
        accordionTrigger.setAttribute('aria-expanded', 'true');
      }
    };

    const filterByFlavor = (flavor) => {
      items.forEach((item) => {
        const showFor = item.dataset.showForFlavor || 'all';
        const shouldShow = showFor === 'all' || showFor === flavor;

        item.hidden = !shouldShow;

        if (!shouldShow) {
          closeItem(item);
        }
      });

      const visibleItems = items.filter((item) => !item.hidden);
      const hasOpenVisibleItem = visibleItems.some((item) => item.classList.contains('is-open'));

      if (!hasOpenVisibleItem && visibleItems.length > 0) {
        openItem(visibleItems[0]);
      }

      syncAccordionHeight();
    };

    document.addEventListener('shop:product-change', (event) => {
      const detail = event.detail || {};
      const flavor = detail.flavor;

      if (flavor) {
        setHighlightColor(flavor);
        filterByFlavor(flavor);
      }
    });

    if (window.__shopSelection && window.__shopSelection.flavor) {
      setHighlightColor(window.__shopSelection.flavor);
      filterByFlavor(window.__shopSelection.flavor);
    } else {
      setHighlightColor('all');
    }

    items.forEach((item) => {
      const trigger = item.querySelector('[data-as-trigger]');

      if (!trigger) {
        return;
      }

      trigger.addEventListener('click', () => {
        const isOpen = item.classList.contains('is-open');

        if (isOpen) {
          closeItem(item);
        } else {
          items.forEach((otherItem) => {
            if (otherItem !== item) {
              closeItem(otherItem);
            }
          });
          openItem(item);
        }

        syncAccordionHeight();
      });
    });
  });

  // Stagger icon animation on scroll (trigger at 30% visibility)
  const iconObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.querySelectorAll('.accordion-section__icon-item').forEach((item) => {
            item.classList.add('is-visible');
          });
          iconObserver.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.65 }
  );

  document.querySelectorAll('.accordion-section__icon-grid').forEach((grid) => {
    iconObserver.observe(grid);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.querySelectorAll('[data-cart-form]').forEach((formElement) => {
    const quantityInputs = formElement.querySelectorAll('[data-cart-quantity]');

    quantityInputs.forEach((quantityInput) => {
      quantityInput.addEventListener('change', () => {
        if (typeof formElement.requestSubmit === 'function') {
          formElement.requestSubmit();
          return;
        }

        formElement.submit();
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collage-section"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__collageSectionParallaxInitialized) return;
    window.__collageSectionParallaxInitialized = true;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (reduceMotion.matches) return;

    const sections = document.querySelectorAll('[data-collage-parallax]');
    if (!sections.length) return;

    const stacks = Array.from(sections).flatMap((section) =>
      Array.from(section.querySelectorAll('.collage-section__stack'))
    );

    if (!stacks.length) return;

    let isTicking = false;

    const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

    const updateParallax = () => {
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

      stacks.forEach((stack) => {
        const rect = stack.getBoundingClientRect();
        const centerOffset = rect.top + rect.height * 0.5 - viewportHeight * 0.5;
        const progress = clamp(centerOffset / viewportHeight, -1.2, 1.2);

        stack.querySelectorAll('.collage-section__tile').forEach((tile) => {
          const depth = Number(tile.dataset.depth || '0.12');
          const direction = tile.dataset.direction === 'left' ? -1 : 1;
          const x = progress * depth * 34 * direction;
          const y = progress * depth * 340;

          tile.style.transform = `translate3d(${x.toFixed(2)}px, ${y.toFixed(2)}px, 0)`;
        });
      });

      isTicking = false;
    };

    const requestParallaxUpdate = () => {
      if (isTicking) return;
      isTicking = true;
      window.requestAnimationFrame(updateParallax);
    };

    window.addEventListener('scroll', requestParallaxUpdate, { passive: true });
    window.addEventListener('resize', requestParallaxUpdate, { passive: true });

    requestParallaxUpdate();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-accordion-section"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-faq-section]').forEach(function (sectionRoot) {
    var accordion = sectionRoot.querySelector('[data-faq-accordion]');
    if (!accordion) return;

    var items = Array.from(accordion.querySelectorAll('[data-faq-item]'));

    function closeItem(item) {
      item.classList.remove('is-open');
      var trigger = item.querySelector('[data-faq-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    }

    function openItem(item) {
      item.classList.add('is-open');
      var trigger = item.querySelector('[data-faq-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
    }

    items.forEach(function (item) {
      var trigger = item.querySelector('[data-faq-trigger]');
      if (!trigger) return;

      trigger.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        if (isOpen) {
          closeItem(item);
        } else {
          items.forEach(function (other) {
            if (other !== item) closeItem(other);
          });
          openItem(item);
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.querySelectorAll('.locale-selector').forEach((form) => {
    const regionSelect = form.querySelector('.locale-selector__select--region');
    const languageSelect = form.querySelector('.locale-selector__select--language');

    if (!regionSelect && !languageSelect) return;

    const handleChange = () => {
      form.submit();
    };

    if (regionSelect) regionSelect.addEventListener('change', handleChange);
    if (languageSelect) languageSelect.addEventListener('change', handleChange);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const headerSectionId = 'header';
    const header = document.querySelector('[data-header-root]');
    const headerDebugEnabled = window.location.search.includes('headerdebug=1');
    const burger = document.querySelector('[data-header-burger]');
    const menu = document.querySelector('[data-header-menu]');

    const getDrawerElements = function () {
      const drawerRoot = document.querySelector('[data-cart-drawer-root]');

      if (!drawerRoot) {
        return null;
      }

      return {
        drawerRoot: drawerRoot,
        drawerPanel: drawerRoot.querySelector('[data-cart-drawer-panel]'),
        drawerCloseButton: drawerRoot.querySelector('[data-cart-drawer-close]'),
        drawerBackdrop: drawerRoot.querySelector('[data-cart-drawer-backdrop]'),
      };
    };

    const getDrawerOpenButtons = function () {
      return Array.from(document.querySelectorAll('[data-cart-drawer-open]'));
    };

    const setDrawerOpenButtonsExpanded = function (isExpanded) {
      getDrawerOpenButtons().forEach(function (button) {
        button.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
      });
    };

    const updateCartCountBadges = function (itemCount) {
      const countSelectors = ['.header__cart-link', '.header__cart-drawer-trigger'];

      countSelectors.forEach(function (selector) {
        document.querySelectorAll(selector).forEach(function (element) {
          const existingCount = element.querySelector('sup');

          if (itemCount > 0) {
            if (existingCount) {
              existingCount.textContent = String(itemCount);
            } else {
              const sup = document.createElement('sup');
              sup.textContent = String(itemCount);
              element.insertBefore(sup, element.firstChild);
            }

            return;
          }

          if (existingCount) {
            existingCount.remove();
          }
        });
      });
    };

    const openDrawer = function () {
      const drawerElements = getDrawerElements();

      if (!drawerElements || !drawerElements.drawerPanel || !drawerElements.drawerBackdrop) {
        return false;
      }

      drawerElements.drawerRoot.setAttribute('data-open', '');
      drawerElements.drawerPanel.setAttribute('aria-hidden', 'false');
      drawerElements.drawerBackdrop.hidden = false;
      document.body.classList.add('is-cart-drawer-open');
      setDrawerOpenButtonsExpanded(true);

      if (drawerElements.drawerCloseButton instanceof HTMLElement) {
        drawerElements.drawerCloseButton.focus();
      }

      return true;
    };

    const closeDrawer = function () {
      const drawerElements = getDrawerElements();

      if (!drawerElements || !drawerElements.drawerPanel || !drawerElements.drawerBackdrop) {
        return false;
      }

      drawerElements.drawerRoot.removeAttribute('data-open');
      drawerElements.drawerPanel.setAttribute('aria-hidden', 'true');
      drawerElements.drawerBackdrop.hidden = true;
      document.body.classList.remove('is-cart-drawer-open');
      setDrawerOpenButtonsExpanded(false);

      return true;
    };

    const applyRenderedHeaderSection = function (headerSectionHtml) {
      if (!headerSectionHtml) {
        return false;
      }

      const drawerElements = getDrawerElements();

      if (!drawerElements) {
        return false;
      }

      const parsedDocument = new DOMParser().parseFromString(headerSectionHtml, 'text/html');
      const freshDrawerRoot = parsedDocument.querySelector('[data-cart-drawer-root]');

      if (!freshDrawerRoot) {
        return false;
      }

      drawerElements.drawerRoot.innerHTML = freshDrawerRoot.innerHTML;
      drawerElements.drawerRoot.removeAttribute('data-open');
      drawerElements.drawerRoot.dataset.headerDrawerBound = 'false';
      document.body.classList.remove('is-cart-drawer-open');
      setDrawerOpenButtonsExpanded(false);

      return true;
    };

    const refreshDrawerFromSection = async function (headerSectionHtml) {
      if (applyRenderedHeaderSection(headerSectionHtml)) {
        return true;
      }

      const sectionUrl = new URL(window.location.href);
      sectionUrl.searchParams.set('sections', headerSectionId);

      const sectionResponse = await fetch(sectionUrl.toString(), {
        headers: {
          Accept: 'application/json',
        },
      });

      if (!sectionResponse.ok) {
        return false;
      }

      const sectionPayload = await sectionResponse.json();
      const fetchedHeaderSectionHtml = sectionPayload && sectionPayload[headerSectionId];

      return applyRenderedHeaderSection(fetchedHeaderSectionHtml);
    };

    const changeDrawerLine = async function (_ref) {
      const line = _ref.line;
      const quantity = _ref.quantity;
      const sellingPlan = _ref.sellingPlan;
      const payload = {
        line: line,
        quantity: quantity,
        sections: headerSectionId,
        sections_url: window.location.pathname + window.location.search,
      };

      if (sellingPlan !== undefined) {
        payload.selling_plan = sellingPlan;
      }

      const response = await fetch(rootPath + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error('Cart change failed');
      }

      return response.json();
    };

    const bindDrawerToggleControls = function () {
      getDrawerOpenButtons().forEach(function (button) {
        if (button.dataset.headerDrawerToggleBound === 'true') {
          return;
        }

        button.addEventListener('click', function (event) {
          event.preventDefault();
          openDrawer();
        });

        button.dataset.headerDrawerToggleBound = 'true';
      });
    };

    const bindDrawerInteractions = function () {
      const drawerElements = getDrawerElements();

      if (!drawerElements || drawerElements.drawerRoot.dataset.headerDrawerBound === 'true') {
        return;
      }

      drawerElements.drawerRoot.addEventListener('click', function (event) {
        const target = event.target;

        if (!(target instanceof Element)) {
          return;
        }

        if (target.closest('[data-cart-drawer-close]') || target.closest('[data-cart-drawer-backdrop]')) {
          event.preventDefault();
          closeDrawer();
          return;
        }

        const removeButton = target.closest('[data-cart-drawer-remove]');

        if (!(removeButton instanceof HTMLButtonElement)) {
          return;
        }

        const line = parseInt(removeButton.getAttribute('data-line') || '', 10);

        if (isNaN(line) || line < 1 || removeButton.disabled) {
          return;
        }

        event.preventDefault();
        removeButton.disabled = true;

        changeDrawerLine({ line: line, quantity: 0 })
          .then(async function (cartPayload) {
            if (typeof cartPayload.item_count === 'number') {
              updateCartCountBadges(cartPayload.item_count);
            }

            const renderedHeaderHtml = cartPayload && cartPayload.sections && cartPayload.sections[headerSectionId];
            await refreshDrawerFromSection(renderedHeaderHtml);
            bindDrawerInteractions();
            bindDrawerToggleControls();
            openDrawer();
          })
          .catch(function () {
            removeButton.disabled = false;
          });
      });

      drawerElements.drawerRoot.addEventListener('change', function (event) {
        const target = event.target;

        if (!(target instanceof HTMLSelectElement)) {
          return;
        }

        const quantitySelect = target.closest('[data-cart-drawer-quantity]');

        if (quantitySelect instanceof HTMLSelectElement) {
          const line = parseInt(quantitySelect.getAttribute('data-line') || '', 10);
          const quantity = parseInt(quantitySelect.value || '', 10);

          if (isNaN(line) || line < 1 || isNaN(quantity) || quantity < 1 || quantitySelect.disabled) {
            return;
          }

          quantitySelect.disabled = true;

          changeDrawerLine({ line: line, quantity: quantity })
            .then(async function (cartPayload) {
              if (typeof cartPayload.item_count === 'number') {
                updateCartCountBadges(cartPayload.item_count);
              }

              const renderedHeaderHtml = cartPayload && cartPayload.sections && cartPayload.sections[headerSectionId];
              await refreshDrawerFromSection(renderedHeaderHtml);
              bindDrawerInteractions();
              bindDrawerToggleControls();
              openDrawer();
            })
            .catch(function () {
              quantitySelect.disabled = false;
            });

          return;
        }

        const sellingPlanSelect = target.closest('[data-cart-selling-plan]');

        if (!(sellingPlanSelect instanceof HTMLSelectElement) || sellingPlanSelect.disabled) {
          return;
        }

        const line = parseInt(sellingPlanSelect.getAttribute('data-line') || '', 10);
        const quantity = parseInt(sellingPlanSelect.getAttribute('data-quantity') || '', 10);
        const rawValue = sellingPlanSelect.value;
        const sellingPlan = rawValue === '' ? '' : parseInt(rawValue, 10);
        const selectWrapper = sellingPlanSelect.parentNode;

        if (isNaN(line) || line < 1 || isNaN(quantity) || quantity < 1) {
          return;
        }

        if (rawValue !== '' && isNaN(sellingPlan)) {
          return;
        }

        sellingPlanSelect.disabled = true;

        if (selectWrapper instanceof HTMLElement) {
          selectWrapper.style.opacity = '0.5';
        }

        changeDrawerLine({
          line: line,
          quantity: quantity,
          sellingPlan: sellingPlan,
        })
          .then(async function (cartPayload) {
            if (typeof cartPayload.item_count === 'number') {
              updateCartCountBadges(cartPayload.item_count);
            }

            const renderedHeaderHtml = cartPayload && cartPayload.sections && cartPayload.sections[headerSectionId];
            await refreshDrawerFromSection(renderedHeaderHtml);
            bindDrawerInteractions();
            bindDrawerToggleControls();
            openDrawer();
          })
          .catch(function () {
            sellingPlanSelect.disabled = false;

            if (selectWrapper instanceof HTMLElement) {
              selectWrapper.style.opacity = '';
            }
          });
      });

      drawerElements.drawerRoot.dataset.headerDrawerBound = 'true';
    };

    if (header) {
      if (headerDebugEnabled) {
        console.info('[Header Debug]', {
          currentTemplateKey: header.dataset.currentTemplateKey,
          currentTemplateBase: header.dataset.currentTemplateBase,
          currentTemplateSuffix: header.dataset.currentTemplateSuffix,
          currentPageHandle: header.dataset.currentPageHandle,
          currentPageHandleKey: header.dataset.currentPageHandleKey,
          configuredTemplateKeys: header.dataset.configuredTemplateKeys,
          matchedTemplateKey: header.dataset.matchedTemplateKey,
          matchedTemplateReason: header.dataset.matchedTemplateReason,
          forceSurface: header.dataset.forceSurface,
          hasSurfaceAlwaysVisibleAttr: header.hasAttribute('data-surface-always-visible'),
        });
      }

      if (header.hasAttribute('data-surface-always-visible')) {
        header.classList.add('header--surface-visible');
      } else {
        const scrollThreshold = 100;
        let ticking = false;

        const syncHeaderSurface = function () {
          const shouldShowSurface = window.scrollY > scrollThreshold;
          header.classList.toggle('header--surface-visible', shouldShowSurface);
        };

        const onScroll = function () {
          if (ticking) return;

          ticking = true;
          window.requestAnimationFrame(function () {
            syncHeaderSurface();
            ticking = false;
          });
        };

        window.addEventListener('scroll', onScroll, { passive: true });
        syncHeaderSurface();
      }
    }

    bindDrawerToggleControls();
    bindDrawerInteractions();

    if (!window.__headerDrawerEscBound) {
      document.addEventListener('keydown', function (event) {
        const drawerElements = getDrawerElements();

        if (event.key !== 'Escape' || !drawerElements || !drawerElements.drawerRoot.hasAttribute('data-open')) {
          return;
        }

        closeDrawer();

        const firstOpenButton = getDrawerOpenButtons()[0];

        if (firstOpenButton instanceof HTMLElement) {
          firstOpenButton.focus();
        }
      });

      window.__headerDrawerEscBound = true;
    }

    window.SuelCartDrawer = {
      open: openDrawer,
      close: closeDrawer,
      bind: function () {
        bindDrawerToggleControls();
        bindDrawerInteractions();
      },
      refreshFromSection: async function (headerSectionHtml) {
        const refreshed = await refreshDrawerFromSection(headerSectionHtml);

        if (refreshed) {
          bindDrawerToggleControls();
          bindDrawerInteractions();
        }

        return refreshed;
      },
      updateCountBadges: updateCartCountBadges,
    };

    if (!burger || !menu) return;

    const menuLinks = menu.querySelectorAll('.header__menu-link');
    const accountLinks = menu.querySelectorAll('.header__menu-account-link');

    // Toggle menu on burger click
    burger.addEventListener('click', function () {
      const isOpen = menu.hasAttribute('data-menu-open');

      if (isOpen) {
        menu.removeAttribute('data-menu-open');
        burger.setAttribute('aria-expanded', 'false');
      } else {
        menu.setAttribute('data-menu-open', '');
        burger.setAttribute('aria-expanded', 'true');
      }
    });

    accountLinks.forEach((link) => {
      link.addEventListener('click', function (e) {
        // Allow logout link to work without closing menu first
        if (!this.attributes.onclick) {
          menu.removeAttribute('data-menu-open');
          burger.setAttribute('aria-expanded', 'false');
        }
      });
    });

    // Close menu on Escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.hasAttribute('data-menu-open')) {
        menu.removeAttribute('data-menu-open');
        burger.setAttribute('aria-expanded', 'false');
        burger.focus();
      }
    });

    // Close menu when clicking outside
    document.addEventListener('click', function (e) {
      if (!burger.contains(e.target) && !menu.contains(e.target) && menu.hasAttribute('data-menu-open')) {
        menu.removeAttribute('data-menu-open');
        burger.setAttribute('aria-expanded', 'false');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-ingredient"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const section = document.querySelector('[data-our-ingredient]');
    if (!section) return;

    // --- Decor parallax ---
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const leftWrappers = Array.from(section.querySelectorAll('[data-decor-wrapper][data-decor-side="left"]'));
      const rightWrappers = Array.from(section.querySelectorAll('[data-decor-wrapper][data-decor-side="right"]'));

      if (leftWrappers.length && rightWrappers.length) {
        const lerp = (a, b, t) => a + (b - a) * Math.max(0, Math.min(1, t));

        const animate = () => {
          const rect = section.getBoundingClientRect();
          const vh = window.innerHeight;
          const sectionCenter = rect.top + rect.height / 2;
          const progress = lerp(0, 1, (vh - sectionCenter) / (vh * 0.5));
          const isMobileViewport = window.innerWidth < 750;
          const slideDistance = isMobileViewport ? 120 : 80;
          const leftX = lerp(-slideDistance, 0, progress);
          const rightX = lerp(slideDistance, 0, progress);

          leftWrappers.forEach((wrapper) => {
            wrapper.style.transform = `translateX(${leftX}px)`;
          });

          rightWrappers.forEach((wrapper) => {
            wrapper.style.transform = `translateX(${rightX}px)`;
          });
        };

        window.addEventListener('scroll', animate, { passive: true });
        animate();
      }
    }

    // --- Battery interaction ---
    const battery = section.querySelector('[data-battery]');
    if (battery) {
      const imgs = Array.from(battery.querySelectorAll('.our-ingredient__battery-img'));
      const zones = battery.querySelectorAll('.our-ingredient__battery-zone');
      let animated = false;

      let activeIndex = 0;
      let cleanupTimer = null;

      const setActive = (index) => {
        if (activeIndex === index) return;

        const prevImg = imgs[activeIndex];
        const newImg = imgs[index];

        // Cancel any pending cleanup from a previous transition
        if (cleanupTimer) clearTimeout(cleanupTimer);

        // Bring new image on top and fade it in
        newImg.style.zIndex = '3';
        newImg.classList.add('is-active');
        activeIndex = index;

        // After fade completes, hide the old image and reset z-index
        cleanupTimer = setTimeout(() => {
          imgs.forEach((img, i) => {
            if (i !== activeIndex) {
              img.classList.remove('is-active');
              img.style.zIndex = '';
            }
          });
          newImg.style.zIndex = '';
          cleanupTimer = null;
        }, 300);
      };

      // Hover zones — column-reverse means zone[0] is at the bottom (Battery1 = lowest)
      zones.forEach((zone, i) => {
        zone.addEventListener('mouseenter', () => setActive(i));
      });

      // On mouse leave, settle on Battery6 (full)
      battery.addEventListener('mouseleave', () => setActive(imgs.length - 1));

      // Entry animation: cycle Battery1 → Battery6 once when the battery reaches the viewport center
      const runEntryAnimation = () => {
        if (animated) return;
        animated = true;
        let i = 0;
        const step = () => {
          setActive(i);
          i++;
          if (i < imgs.length) setTimeout(step, 150);
        };
        step();
      };

      const observer = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) {
            runEntryAnimation();
            observer.disconnect();
          }
        },
        {
          threshold: 0,
          rootMargin: '-45% 0px -45% 0px',
        }
      );
      observer.observe(battery);

      // Switch battery image set based on selected variant
      const batteryBase = battery.querySelector('.our-ingredient__battery-base');

      const applyBatteryVariant = (flavor) => {
        const isSuperstrong = flavor === 'Superstrong Sour Ginger';
        const key = isSuperstrong ? 'srcSuperstrong' : 'srcDefault';
        if (batteryBase) batteryBase.data = batteryBase.dataset[key];
        imgs.forEach((img) => {
          img.data = img.dataset[key];
        });

        const caffeineLabels = section.querySelectorAll('[data-caffeine-label]');
        caffeineLabels.forEach((label) => {
          const labelKey = isSuperstrong ? 'labelSuperstrong' : 'labelDefault';
          label.textContent = label.dataset[labelKey] || label.dataset.labelDefault;
        });
      };

      document.addEventListener('shop:product-change', (event) => {
        applyBatteryVariant((event.detail && event.detail.flavor) || '');
      });

      // Apply immediately if a variant was already selected before this section loaded
      if (window.__shopSelection) {
        applyBatteryVariant(window.__shopSelection.flavor || '');
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-header"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-shop-header]').forEach((shopHeaderSection) => {
    const sectionRoot = shopHeaderSection;
    const activeImage = shopHeaderSection.querySelector('[data-shop-header-image]');
    const tabs = Array.from(shopHeaderSection.querySelectorAll('[data-shop-header-button]'));
    let isTransitioning = false;

    if (tabs.length == 0 || !sectionRoot) {
      return;
    }

    // Preload all variant images and background images so tab switches are instant
    tabs.forEach((tab) => {
      const url = tab.dataset.imageUrl;
      if (url) {
        const preloadImg = new Image();
        preloadImg.src = url;
      }
      [tab.dataset.backgroundMobileUrl, tab.dataset.backgroundDesktopUrl].forEach((bgUrl) => {
        if (bgUrl) {
          const preloadBg = new Image();
          preloadBg.src = bgUrl;
        }
      });
    });

    const bgContainer = shopHeaderSection.querySelector('[data-shop-header-bg]');
    const bgMobileImg = bgContainer ? bgContainer.querySelector('.shop-header__bg-image--mobile') : null;
    const bgDesktopImg = bgContainer ? bgContainer.querySelector('.shop-header__bg-image--desktop') : null;

    const fadeBgImg = (imgEl, newUrl) => {
      if (!imgEl) return;
      if (!newUrl) {
        imgEl.style.transition = 'none';
        imgEl.style.opacity = '0';
        imgEl.style.display = 'none';
        return;
      }
      imgEl.style.display = '';
      if (imgEl.src === newUrl) {
        imgEl.style.transition = 'none';
        void imgEl.offsetWidth;
        imgEl.style.opacity = '1';
        return;
      }
      // Snap to invisible, swap src (preloaded so instant), then fade in
      imgEl.style.transition = 'none';
      imgEl.style.opacity = '0';
      imgEl.src = newUrl;
      void imgEl.offsetWidth;
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          imgEl.style.transition = '';
          imgEl.style.opacity = '1';
        });
      });
    };

    const updateBgImages = (tab) => {
      const mobileUrl = tab.dataset.backgroundMobileUrl || '';
      const desktopUrl = tab.dataset.backgroundDesktopUrl || '';
      fadeBgImg(bgMobileImg, mobileUrl);
      fadeBgImg(bgDesktopImg, desktopUrl);
    };

    const emitProductChange = (tab, source = 'header') => {
      const detail = {
        productHandle: tab.dataset.productHandle || '',
        flavor: tab.dataset.packSize || '',
        variantId: tab.dataset.variantId || '',
        packSize: tab.dataset.packSize || '',
        backgroundColor: tab.dataset.backgroundColor || '',
        source,
      };

      window.__shopSelection = detail;

      document.dispatchEvent(
        new CustomEvent('shop:product-change', {
          detail,
        })
      );
    };

    const setActiveTab = (tab) => {
      tabs.forEach((item) => {
        item.classList.remove('is-active');
        item.classList.remove('text-heading-xl');
        item.classList.add('text-heading-xs');
        item.setAttribute('aria-pressed', 'false');
      });

      tab.classList.add('is-active');
      tab.classList.remove('text-heading-xs');
      tab.classList.add('text-heading-xl');
      tab.setAttribute('aria-pressed', 'true');
    };

    const updateActiveImage = (tab) => {
      const imageUrl = tab.dataset.imageUrl;
      const imageAlt = tab.dataset.imageAlt || '';
      const imageWidth = tab.dataset.imageWidth;
      const imageHeight = tab.dataset.imageHeight;

      if (!imageUrl || !activeImage) {
        return;
      }

      const currentImageUrl = activeImage.currentSrc || activeImage.getAttribute('src') || '';

      if (currentImageUrl == imageUrl) {
        activeImage.alt = imageAlt;

        if (imageWidth && imageHeight) {
          activeImage.width = Number(imageWidth);
          activeImage.height = Number(imageHeight);
        }

        return;
      }

      isTransitioning = true;

      const nextImage = new Image();
      nextImage.src = imageUrl;

      const doSwap = () => {
        // At 90° the card is edge-on and invisible — snap to the mirror side
        // (-90°) with no transition so the viewer sees a continuous 180° spin
        activeImage.classList.remove('is-transitioning');
        activeImage.style.transition = 'none';
        activeImage.style.transform = 'rotateY(-90deg)';

        // Swap src while invisible
        activeImage.src = imageUrl;
        activeImage.alt = imageAlt;
        if (imageWidth && imageHeight) {
          activeImage.width = Number(imageWidth);
          activeImage.height = Number(imageHeight);
        }

        const spinBack = () => {
          // Force a reflow so the browser registers the -90deg position before
          // we re-enable the transition, then animate back to 0deg
          void activeImage.offsetWidth;
          activeImage.style.transition = 'transform 200ms ease-out';
          activeImage.style.transform = 'rotateY(0deg)';

          activeImage.addEventListener(
            'transitionend',
            () => {
              // Clean up inline styles so CSS classes take over again
              activeImage.style.transition = '';
              activeImage.style.transform = '';
              isTransitioning = false;
            },
            { once: true }
          );
        };

        if (nextImage.complete) {
          spinBack();
        } else {
          activeImage.addEventListener('load', spinBack, { once: true });
        }
      };

      // Wait for the first half-spin (0° → 90°) to complete before swapping
      activeImage.addEventListener('transitionend', doSwap, { once: true });

      requestAnimationFrame(() => {
        activeImage.classList.add('is-transitioning');
      });
    };

    const applyTabState = (tab) => {
      const backgroundColor = tab.dataset.backgroundColor;

      setActiveTab(tab);

      if (backgroundColor) {
        sectionRoot.style.setProperty('--shop-header-background', backgroundColor);
      }

      const isLightVariant = (tab.dataset.packSize || '') === 'Sour Ginger';
      sectionRoot.classList.toggle('shop-header--light-variant', isLightVariant);

      updateBgImages(tab);

      if (isTransitioning) {
        return;
      }

      updateActiveImage(tab);
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        if (isTransitioning) {
          return;
        }

        applyTabState(tab);
        emitProductChange(tab, 'header');
      });
    });

    document.addEventListener('shop:product-change', (event) => {
      const detail = event.detail || {};

      if (detail.source == 'header') {
        return;
      }

      let nextTab = tabs.find((tab) => tab.dataset.variantId == detail.variantId);

      if (!nextTab) {
        if (detail.packSize) {
          nextTab = tabs.find((tab) => tab.dataset.packSize == detail.packSize);
        }
      }

      if (nextTab) {
        applyTabState(nextTab);
      }
    });

    const initialActiveTab = tabs.find((tab) => tab.classList.contains('is-active')) || tabs[0];

    if (initialActiveTab) {
      applyTabState(initialActiveTab);
      emitProductChange(initialActiveTab, 'header');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-products"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const cartJsUrl = `${rootPath}cart.js`;
    const headerSectionId = 'header';

    const updateCartCountBadges = (itemCount) => {
      const countSelectors = ['.header__cart-link', '.header__cart-drawer-trigger'];

      countSelectors.forEach((selector) => {
        document.querySelectorAll(selector).forEach((el) => {
          const existingCount = el.querySelector('sup');

          if (itemCount > 0) {
            if (existingCount) {
              existingCount.textContent = String(itemCount);
            } else {
              const sup = document.createElement('sup');
              sup.textContent = String(itemCount);
              el.insertBefore(sup, el.firstChild);
            }
          } else if (existingCount) {
            existingCount.remove();
          }
        });
      });
    };

    const getCartDrawerApi = () => {
      if (window.SuelCartDrawer && typeof window.SuelCartDrawer.refreshFromSection === 'function') {
        return window.SuelCartDrawer;
      }

      return null;
    };

    document.addEventListener('submit', async (event) => {
      const form = event.target;

      if (!(form instanceof HTMLFormElement) || !form.matches('.shop-products__add-to-cart-form')) {
        return;
      }

      event.preventDefault();

      const submitButton = form.querySelector('button[type="submit"]');

      if (!submitButton || submitButton.disabled) {
        return;
      }

      submitButton.disabled = true;

      try {
        const addFormData = new FormData(form);
        addFormData.set('sections', headerSectionId);
        addFormData.set('sections_url', `${window.location.pathname}${window.location.search}`);

        const addResponse = await fetch(`${form.action}.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
          },
          body: addFormData,
        });

        if (!addResponse.ok) {
          throw new Error('Add to cart failed');
        }

        const addPayload = await addResponse.json();

        const cartResponse = await fetch(cartJsUrl, {
          headers: {
            Accept: 'application/json',
          },
        });

        if (cartResponse.ok) {
          const cart = await cartResponse.json();

          if (typeof cart.item_count === 'number') {
            const drawerApi = getCartDrawerApi();

            if (drawerApi && typeof drawerApi.updateCountBadges === 'function') {
              drawerApi.updateCountBadges(cart.item_count);
            } else {
              updateCartCountBadges(cart.item_count);
            }
          }
        }

        const renderedHeaderHtml = addPayload && addPayload.sections && addPayload.sections[headerSectionId];
        const drawerApi = getCartDrawerApi();

        if (!drawerApi) {
          window.location.href = `${rootPath}cart`;
          return;
        }

        await drawerApi.refreshFromSection(renderedHeaderHtml);
        drawerApi.bind();

        if (!drawerApi.open()) {
          window.location.href = `${rootPath}cart`;
        }
      } catch (error) {
        window.location.href = `${rootPath}cart`;
      } finally {
        submitButton.disabled = false;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-sticky-cta"] && !Shopify.designMode) return;
  try {
    
  // QA checklist for this native select behavior:
  // 1) iOS Safari: open/close dropdown with long variant names.
  // 2) Android Chrome: chevron stays next to selected text.
  // 3) Desktop Safari/Chrome: resize + variant switch keeps truncation stable.
  const shopStickyCtaRootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const shopStickyCtaHeaderSectionId = 'header';
  const isShopStickyCtaMobileViewport = () => window.matchMedia('(max-width: 749px)').matches;
  const truncateShopStickyCtaLabelToWidth = (label, maxWidth, measureLabelWidth) => {
    if (!label) {
      return label;
    }

    if (maxWidth <= 0 || measureLabelWidth(label) <= maxWidth) {
      return label;
    }

    const ellipsis = '...';

    if (measureLabelWidth(ellipsis) > maxWidth) {
      return '';
    }

    let low = 0;
    let high = label.length;
    let best = '';

    while (low <= high) {
      const mid = Math.floor((low + high) / 2);
      const candidate = `${label.slice(0, mid).trimEnd()}${ellipsis}`;

      if (measureLabelWidth(candidate) <= maxWidth) {
        best = candidate;
        low = mid + 1;
      } else {
        high = mid - 1;
      }
    }

    return best || ellipsis;
  };

  document.querySelectorAll('[data-shop-sticky-cta]').forEach((sectionRoot) => {
    const updateCartCountBadges = (itemCount) => {
      const countSelectors = ['.header__cart-link', '.header__cart-drawer-trigger'];

      countSelectors.forEach((selector) => {
        document.querySelectorAll(selector).forEach((el) => {
          const existingCount = el.querySelector('sup');

          if (itemCount > 0) {
            if (existingCount) {
              existingCount.textContent = String(itemCount);
            } else {
              const sup = document.createElement('sup');
              sup.textContent = String(itemCount);
              el.insertBefore(sup, el.firstChild);
            }
          } else if (existingCount) {
            existingCount.remove();
          }
        });
      });
    };

    const applyRenderedHeaderSection = (headerSectionHtml) => {
      if (!headerSectionHtml) {
        return false;
      }

      const drawerPanel = document.querySelector('[data-cart-drawer-panel]');

      if (!drawerPanel) {
        return false;
      }

      const parsedDocument = new DOMParser().parseFromString(headerSectionHtml, 'text/html');
      const freshDrawerPanel = parsedDocument.querySelector('[data-cart-drawer-panel]');

      if (!freshDrawerPanel) {
        return false;
      }

      const currentHeader = drawerPanel.querySelector('.header-cart-drawer__header');
      const freshChildren = Array.from(freshDrawerPanel.children).filter(
        (child) => !child.classList.contains('header-cart-drawer__header')
      );

      Array.from(drawerPanel.children).forEach((child) => {
        if (child !== currentHeader) {
          child.remove();
        }
      });

      freshChildren.forEach((child) => {
        drawerPanel.appendChild(child.cloneNode(true));
      });

      return true;
    };

    const refreshDrawerFromSection = async (headerSectionHtml) => {
      if (applyRenderedHeaderSection(headerSectionHtml)) {
        return true;
      }

      const sectionUrl = new URL(window.location.href);
      sectionUrl.searchParams.set('sections', shopStickyCtaHeaderSectionId);

      const sectionResponse = await fetch(sectionUrl.toString(), {
        headers: {
          Accept: 'application/json',
        },
      });

      if (!sectionResponse.ok) {
        return false;
      }

      const sectionPayload = await sectionResponse.json();
      const fetchedHeaderSectionHtml = sectionPayload && sectionPayload[shopStickyCtaHeaderSectionId];

      return applyRenderedHeaderSection(fetchedHeaderSectionHtml);
    };

    const openHeaderCartDrawer = () => {
      const drawerOpenButton = document.querySelector('[data-cart-drawer-open]');

      if (!(drawerOpenButton instanceof HTMLButtonElement)) {
        return false;
      }

      drawerOpenButton.click();
      return true;
    };

    const setStickyTopOffset = () => {
      const navHeader =
        document.querySelector('#shopify-section-header header') ||
        document.querySelector('#shopify-section-header-group header') ||
        document.querySelector('header');
      const navHeight = navHeader ? Math.round(navHeader.getBoundingClientRect().height) : 0;

      document.documentElement.style.setProperty('--shop-nav-height', `${navHeight}px`);
    };

    const setStickyCtaHeight = () => {
      const ctaHeight = sectionRoot.offsetHeight || 0;
      document.documentElement.style.setProperty('--shop-sticky-cta-height', `${ctaHeight}px`);
    };

    setStickyTopOffset();
    setStickyCtaHeight();

    if (typeof ResizeObserver === 'function') {
      const navHeader =
        document.querySelector('#shopify-section-header header') ||
        document.querySelector('#shopify-section-header-group header') ||
        document.querySelector('header');

      const stickyCtaResizeObserver = new ResizeObserver(() => {
        setStickyCtaHeight();
      });

      stickyCtaResizeObserver.observe(sectionRoot);

      if (navHeader) {
        const headerResizeObserver = new ResizeObserver(() => {
          setStickyTopOffset();
        });

        headerResizeObserver.observe(navHeader);
      }
    } else {
      window.addEventListener('resize', setStickyTopOffset);
      window.addEventListener('resize', setStickyCtaHeight);
    }

    const panels = Array.from(sectionRoot.querySelectorAll('[data-shop-sticky-cta-panel]'));
    const variantSelects = Array.from(sectionRoot.querySelectorAll('[data-shop-sticky-cta-variant-select]'));

    if (panels.length === 0) {
      return;
    }

    const setActivePanel = (nextPanel) => {
      panels.forEach((panel) => {
        panel.classList.toggle('is-active', panel === nextPanel);
      });
    };

    const emitProductChange = (panel, variantId, backgroundColor, packSize, source = 'cta') => {
      const detail = {
        productHandle: panel.dataset.productHandle || '',
        flavor: packSize || '',
        variantId: variantId || '',
        backgroundColor: backgroundColor || panel.dataset.backgroundColor || '',
        packSize: packSize || '',
        source,
      };

      window.__shopSelection = detail;

      document.dispatchEvent(
        new CustomEvent('shop:product-change', {
          detail,
        })
      );
    };

    const syncPanelVariant = (panel, variantId, packSize) => {
      if (!panel || !variantId) {
        if (!packSize) {
          return;
        }
      }

      const select = panel.querySelector('[data-shop-sticky-cta-variant-select]');

      if (!select) {
        return;
      }

      let option = Array.from(select.options).find((item) => item.value === variantId);

      if (!option) {
        if (packSize) {
          option = Array.from(select.options).find((item) => item.dataset.packSize === packSize);
        }
      }

      if (!option) {
        return;
      }

      select.value = variantId;

      if (typeof select.syncVariantState == 'function') {
        select.syncVariantState(false);
      }
    };

    variantSelects.forEach((select) => {
      const panel = select.closest('[data-shop-sticky-cta-panel]');
      const price = panel ? panel.querySelector('[data-shop-sticky-cta-variant-price]') : null;
      const subtitle = panel ? panel.querySelector('[data-variant-subtitle]') : null;
      const subtitleMapElement = panel ? panel.querySelector('[data-variant-subtitles]') : null;

      const measureLabelWidth = (label) => {
        const computed = window.getComputedStyle(select);
        const measurer = document.createElement('span');
        measurer.style.position = 'absolute';
        measurer.style.visibility = 'hidden';
        measurer.style.pointerEvents = 'none';
        measurer.style.whiteSpace = 'pre';
        measurer.style.fontFamily = computed.fontFamily;
        measurer.style.fontSize = computed.fontSize;
        measurer.style.fontWeight = computed.fontWeight;
        measurer.style.letterSpacing = computed.letterSpacing;
        measurer.textContent = label;
        document.body.appendChild(measurer);

        const width = measurer.getBoundingClientRect().width;
        measurer.remove();

        return width;
      };

      const syncOptionLabelsToWidth = () => {
        const computed = window.getComputedStyle(select);
        const paddingLeft = Number.parseFloat(computed.paddingLeft) || 0;
        const paddingRight = Number.parseFloat(computed.paddingRight) || 0;
        const labelWidth = Math.max(0, select.clientWidth - paddingLeft - paddingRight);

        if (labelWidth <= 0) {
          return;
        }

        Array.from(select.options).forEach((option) => {
          if (!option.dataset.fullLabel) {
            option.dataset.fullLabel = (option.label || option.textContent || '').trim();
          }

          const fullLabel = option.dataset.fullLabel;
          const baseLabel =
            isShopStickyCtaMobileViewport() && option.dataset.shortLabel ? option.dataset.shortLabel : fullLabel;
          const visibleLabel = truncateShopStickyCtaLabelToWidth(baseLabel, labelWidth, measureLabelWidth);

          if (option.label != visibleLabel) {
            option.label = visibleLabel;
          }

          if (option.textContent != visibleLabel) {
            option.textContent = visibleLabel;
          }

          option.title = fullLabel;
        });
      };

      const restoreFullOptionLabels = () => {
        Array.from(select.options).forEach((option) => {
          if (!option.dataset.fullLabel) {
            option.dataset.fullLabel = (option.label || option.textContent || '').trim();
          }

          const fullLabel = option.dataset.fullLabel;
          if (option.label != fullLabel) {
            option.label = fullLabel;
          }

          if (option.textContent != fullLabel) {
            option.textContent = fullLabel;
          }

          option.title = fullLabel;
        });
      };

      const syncSelectWidth = () => {
        const selectedOption = select.options[select.selectedIndex];

        if (!selectedOption) {
          return;
        }

        const computed = window.getComputedStyle(select);
        const paddingLeft = Number.parseFloat(computed.paddingLeft) || 0;
        const paddingRight = Number.parseFloat(computed.paddingRight) || 0;
        const fullLabel =
          isShopStickyCtaMobileViewport() && selectedOption.dataset.shortLabel
            ? selectedOption.dataset.shortLabel
            : (selectedOption.dataset.fullLabel || selectedOption.label || selectedOption.textContent || '').trim();

        if (!fullLabel) {
          return;
        }

        const desiredWidth = Math.ceil(measureLabelWidth(fullLabel) + paddingLeft + paddingRight);
        const cellMaxWidth = select.parentElement ? select.parentElement.clientWidth : select.clientWidth;
        const maxWidthByChars = Math.ceil(measureLabelWidth('0000000000000000000000000') + paddingLeft + paddingRight);
        let maxAllowedWidth = Math.max(0, cellMaxWidth || desiredWidth);

        if (isShopStickyCtaMobileViewport()) {
          maxAllowedWidth = Math.min(maxAllowedWidth, maxWidthByChars);
        }

        const finalWidth = Math.max(0, Math.min(desiredWidth, maxAllowedWidth));
        const widthValue = `${finalWidth}px`;
        const maxWidthValue = `${maxAllowedWidth}px`;

        if (select.style.width != widthValue) {
          select.style.setProperty('width', widthValue, 'important');
        }

        if (select.style.maxWidth != maxWidthValue) {
          select.style.setProperty('max-width', maxWidthValue, 'important');
        }
      };

      if (!panel || !price) {
        return;
      }

      let variantSubtitles = {};

      if (subtitleMapElement) {
        try {
          variantSubtitles = JSON.parse(subtitleMapElement.textContent || '{}');
        } catch (error) {
          variantSubtitles = {};
        }
      }

      const availabilityMapElement = panel ? panel.querySelector('[data-variant-availability]') : null;
      let variantAvailability = {};

      if (availabilityMapElement) {
        try {
          variantAvailability = JSON.parse(availabilityMapElement.textContent || '{}');
        } catch (error) {
          variantAvailability = {};
        }
      }

      const submitButtons = panel ? Array.from(panel.querySelectorAll('[data-shop-sticky-cta-submit]')) : [];
      const mobileSubmitButtons = submitButtons.filter((button) =>
        button.classList.contains('shop-sticky-cta__submit-mobile')
      );
      const desktopSubmitButtons = submitButtons.filter(
        (button) => !button.classList.contains('shop-sticky-cta__submit-mobile')
      );
      const submitLabels = submitButtons
        .map((button) => button.querySelector('[data-shop-sticky-cta-submit-label]'))
        .filter(Boolean);
      const comingSoon = panel ? panel.querySelector('[data-shop-sticky-cta-coming-soon]') : null;
      let syncVariantFrameId = null;
      let scheduledEmit = false;

      const syncVariant = (shouldEmit = true) => {
        syncSelectWidth();
        syncOptionLabelsToWidth();

        const selectedOption = select.options[select.selectedIndex];

        if (!selectedOption) {
          return;
        }

        price.textContent = selectedOption.dataset.price || '';

        const backgroundColor = selectedOption.dataset.backgroundColor || panel.dataset.backgroundColor || '';

        if (backgroundColor) {
          panel.dataset.backgroundColor = backgroundColor;
          sectionRoot.style.setProperty('--shop-sticky-cta-background', backgroundColor);
        }

        if (subtitle) {
          const subtitleText = variantSubtitles[selectedOption.value] || '';

          subtitle.textContent = subtitleText;

          if (subtitleText) {
            subtitle.removeAttribute('hidden');
          } else {
            subtitle.setAttribute('hidden', 'hidden');
          }
        }

        const isPreorder = selectedOption.dataset.preorder === 'true';
        const isAvailable = variantAvailability[selectedOption.value] !== false || isPreorder;

        if (submitButtons.length > 0) {
          const addLabel = submitButtons[0].dataset.addLabel || '';
          const preorderLabel = submitButtons[0].dataset.preorderLabel || addLabel;
          const nextSubmitLabel = isPreorder ? preorderLabel : addLabel;

          submitLabels.forEach((submitLabel) => {
            if (submitLabel.textContent != nextSubmitLabel) {
              submitLabel.textContent = nextSubmitLabel;
            }
          });

          submitButtons.forEach((submitButton) => {
            if (submitButton.getAttribute('aria-label') != nextSubmitLabel) {
              submitButton.setAttribute('aria-label', nextSubmitLabel);
            }

            if (submitButton.getAttribute('title') != nextSubmitLabel) {
              submitButton.setAttribute('title', nextSubmitLabel);
            }
          });
        }

        if (desktopSubmitButtons.length > 0) {
          if (isAvailable) {
            desktopSubmitButtons.forEach((submitButton) => {
              submitButton.removeAttribute('hidden');
            });
          } else {
            desktopSubmitButtons.forEach((submitButton) => {
              submitButton.setAttribute('hidden', 'hidden');
            });
          }

          desktopSubmitButtons.forEach((submitButton) => {
            submitButton.classList.toggle('is-preorder', isPreorder);
          });
        }

        if (mobileSubmitButtons.length > 0) {
          mobileSubmitButtons.forEach((submitButton) => {
            submitButton.disabled = !isAvailable;
            submitButton.setAttribute('aria-disabled', String(!isAvailable));
            submitButton.classList.toggle('is-preorder', isPreorder);
          });
        }

        if (comingSoon) {
          if (isAvailable) {
            comingSoon.setAttribute('hidden', 'hidden');
          } else {
            comingSoon.removeAttribute('hidden');
          }
        }

        if (shouldEmit) {
          emitProductChange(panel, selectedOption.value, backgroundColor, selectedOption.dataset.packSize || '', 'cta');
        }

        setStickyCtaHeight();
      };

      const scheduleSyncVariant = (shouldEmit = false) => {
        if (shouldEmit) {
          scheduledEmit = true;
        }

        if (syncVariantFrameId !== null) {
          return;
        }

        syncVariantFrameId = window.requestAnimationFrame(() => {
          syncVariantFrameId = null;
          const emitNow = scheduledEmit;
          scheduledEmit = false;
          syncVariant(emitNow);
        });
      };

      select.syncVariantState = syncVariant;

      syncVariant(false);
      const prepareSelectForOpen = () => {
        restoreFullOptionLabels();
        syncSelectWidth();
      };

      select.addEventListener('mousedown', prepareSelectForOpen);
      select.addEventListener('focus', prepareSelectForOpen);
      select.addEventListener('touchstart', prepareSelectForOpen, { passive: true });
      select.addEventListener('keydown', (event) => {
        if (event.key == 'Enter' || event.key == ' ' || event.key == 'ArrowDown' || event.key == 'ArrowUp') {
          prepareSelectForOpen();
        }
      });
      select.addEventListener('blur', () => scheduleSyncVariant(false));
      select.addEventListener('change', () => scheduleSyncVariant(true));
      window.addEventListener('resize', () => scheduleSyncVariant(false));
    });

    document.addEventListener('shop:product-change', (event) => {
      const detail = event.detail || {};
      let nextPanel = null;

      if (detail.source == 'cta') {
        return;
      }

      if (detail.productHandle) {
        nextPanel = panels.find((panel) => panel.dataset.productHandle === detail.productHandle);
      }

      if (nextPanel) {
        setActivePanel(nextPanel);
        syncPanelVariant(nextPanel, detail.variantId, detail.packSize);
      }
    });

    if (window.__shopSelection) {
      const detail = window.__shopSelection;
      let nextPanel = null;

      if (detail.productHandle) {
        nextPanel = panels.find((panel) => panel.dataset.productHandle === detail.productHandle);
      }

      if (nextPanel) {
        setActivePanel(nextPanel);
        syncPanelVariant(nextPanel, detail.variantId, detail.packSize);
      }
    }

    sectionRoot.addEventListener('submit', async (event) => {
      const form = event.target;

      if (!(form instanceof HTMLFormElement) || !form.matches('.shop-sticky-cta__form')) {
        return;
      }

      event.preventDefault();

      const submitButtons = Array.from(form.querySelectorAll('[data-shop-sticky-cta-submit]')).filter(
        (button) => button instanceof HTMLButtonElement
      );

      if (submitButtons.some((submitButton) => submitButton.disabled)) {
        return;
      }

      submitButtons.forEach((submitButton) => {
        submitButton.disabled = true;
      });

      try {
        const addFormData = new FormData(form);
        addFormData.set('sections', shopStickyCtaHeaderSectionId);
        addFormData.set('sections_url', `${window.location.pathname}${window.location.search}`);

        const variantSelect = form.querySelector('[data-shop-sticky-cta-variant-select]');
        const selectedVariantOption = variantSelect ? variantSelect.options[variantSelect.selectedIndex] : null;
        const isPreorderVariant = selectedVariantOption && selectedVariantOption.dataset.preorder === 'true';
        const sellingPlanId = selectedVariantOption ? selectedVariantOption.dataset.sellingPlanId : '';

        if (isPreorderVariant && sellingPlanId) {
          addFormData.set('selling_plan', sellingPlanId);
        }

        const addResponse = await fetch(`${shopStickyCtaRootPath}cart/add.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
          },
          body: addFormData,
        });

        if (!addResponse.ok) {
          throw new Error('Add to cart failed');
        }

        const addPayload = await addResponse.json();

        if (typeof addPayload.item_count === 'number') {
          updateCartCountBadges(addPayload.item_count);
        } else {
          const cartResponse = await fetch(`${shopStickyCtaRootPath}cart.js`, {
            headers: {
              Accept: 'application/json',
            },
          });

          if (cartResponse.ok) {
            const cart = await cartResponse.json();

            if (typeof cart.item_count === 'number') {
              updateCartCountBadges(cart.item_count);
            }
          }
        }

        const renderedHeaderHtml =
          addPayload && addPayload.sections && addPayload.sections[shopStickyCtaHeaderSectionId];
        await refreshDrawerFromSection(renderedHeaderHtml);

        if (!openHeaderCartDrawer()) {
          window.location.href = `${shopStickyCtaRootPath}cart`;
        }
      } catch (error) {
        window.location.href = `${shopStickyCtaRootPath}cart`;
      } finally {
        submitButtons.forEach((submitButton) => {
          submitButton.disabled = false;
        });
      }
    });
  });

  // Hide sticky CTA when footer comes into view (mobile only)
  (function () {
    if (window.innerWidth >= 750) return;

    const footer = document.querySelector('footer');
    const ctaSection = document.querySelector('[data-shop-sticky-cta]');

    if (!footer || !ctaSection) return;

    const wrapper = ctaSection.parentElement;

    const observer = new IntersectionObserver(
      ([entry]) => {
        wrapper.style.opacity = entry.isIntersecting ? '0' : '';
        wrapper.style.pointerEvents = entry.isIntersecting ? 'none' : '';
      },
      { threshold: 0 }
    );

    observer.observe(footer);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider-section"] && !Shopify.designMode) return;
  try {
    
  (() => {
    class Slider {
      constructor(root) {
        this.root = root;
        this.track = root.querySelector('[data-slider-track]');
        this.bulletsWrap = root.querySelector('[data-slider-bullets]');
        this.prevBtn = root.querySelector('[data-slider-prev]');
        this.nextBtn = root.querySelector('[data-slider-next]');
        this.currentPage = 0;
        this.allItems = Array.from(root.querySelectorAll('[data-slider-item]'));
        this.visibleItems = this.allItems.slice();

        if (!this.track) return;

        this.bindEvents();
        this.buildBullets();
        this.updateNav();

        if (window.__shopSelection && window.__shopSelection.flavor) {
          this.filterByFlavor(window.__shopSelection.flavor);
        }
      }

      get perPage() {
        const val = getComputedStyle(this.track).getPropertyValue('--slider-per-page');
        return Math.max(1, parseInt(val, 10) || 4);
      }

      get pageCount() {
        return this.getPageOffsets().length;
      }

      getPageOffsets() {
        if (!this.visibleItems.length) return [0];

        const maxScrollLeft = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        if (maxScrollLeft <= 0) return [0];

        // getBoundingClientRect is used instead of offsetLeft because offsetLeft is relative
        // to offsetParent which may not be the track. This approach correctly computes the
        // scroll position needed to bring each page's first item to the track's left edge,
        // regardless of DOM nesting or positioning context.
        const trackLeft = this.track.getBoundingClientRect().left;
        const currentScroll = this.track.scrollLeft;

        const seen = new Set();
        const result = [];

        for (let i = 0; i < this.visibleItems.length; i += this.perPage) {
          const item = this.visibleItems[i];
          if (!item) break;

          const rawOffset = Math.round(item.getBoundingClientRect().left - trackLeft + currentScroll);
          const offset = Math.min(rawOffset, Math.round(maxScrollLeft));

          if (!seen.has(offset)) {
            seen.add(offset);
            result.push(offset);
          }
        }

        return result.length ? result : [0];
      }

      getPageOffset(page) {
        const offsets = this.getPageOffsets();
        const safeIndex = Math.max(0, Math.min(page, offsets.length - 1));
        return offsets[safeIndex] || 0;
      }

      bindEvents() {
        this.prevBtn.addEventListener('click', () => this.goTo(this.currentPage - 1));
        this.nextBtn.addEventListener('click', () => this.goTo(this.currentPage + 1));

        let scrollTimer;
        this.track.addEventListener(
          'scroll',
          () => {
            clearTimeout(scrollTimer);
            scrollTimer = setTimeout(() => this.onScroll(), 60);
          },
          { passive: true }
        );

        document.addEventListener('shop:product-change', (event) => {
          const flavor = event.detail && event.detail.flavor;
          if (flavor) this.filterByFlavor(flavor);
        });

        const ro = new ResizeObserver(() => {
          this.buildBullets();
          this.goTo(0, false);
        });
        ro.observe(this.track);
      }

      filterByFlavor(flavor) {
        this.allItems.forEach((item) => {
          const showFor = item.dataset.showForFlavor || 'all';
          item.hidden = !(showFor === 'all' || showFor === flavor);
        });

        this.visibleItems = this.allItems.filter((item) => !item.hidden);
        this.currentPage = 0;
        // Reset scroll first so getBoundingClientRect values in getPageOffsets are at position 0.
        this.track.scrollLeft = 0;
        this.buildBullets();
        this.updateNav();
      }

      buildBullets() {
        this.bulletsWrap.innerHTML = '';
        const count = this.pageCount;
        this.currentPage = Math.max(0, Math.min(this.currentPage, count - 1));

        for (let i = 0; i < count; i++) {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'slider-section__bullet';
          btn.setAttribute('aria-label', `Page ${i + 1}`);
          if (i === this.currentPage) btn.classList.add('is-active');
          btn.addEventListener('click', () => this.goTo(i));
          this.bulletsWrap.appendChild(btn);
        }
      }

      goTo(page, animate = true) {
        this.currentPage = Math.max(0, Math.min(page, this.pageCount - 1));
        const scrollLeft = this.getPageOffset(this.currentPage);

        if (animate) {
          this.track.scrollTo({ left: scrollLeft, behavior: 'smooth' });
        } else {
          this.track.scrollLeft = scrollLeft;
        }

        this.updateNav();
        this.updateBullets();
      }

      onScroll() {
        const scrollLeft = this.track.scrollLeft;
        const pageOffsets = this.getPageOffsets();
        let nearestPage = 0;
        let nearestDistance = Number.POSITIVE_INFINITY;

        for (let i = 0; i < pageOffsets.length; i++) {
          const pageOffset = pageOffsets[i];
          const distance = Math.abs(pageOffset - scrollLeft);

          if (distance < nearestDistance) {
            nearestDistance = distance;
            nearestPage = i;
          }
        }

        this.currentPage = nearestPage;
        this.updateNav();
        this.updateBullets();
      }

      updateNav() {
        this.prevBtn.disabled = this.currentPage <= 0;
        this.nextBtn.disabled = this.currentPage >= this.pageCount - 1;
      }

      updateBullets() {
        Array.from(this.bulletsWrap.children).forEach((btn, i) => {
          btn.classList.toggle('is-active', i === this.currentPage);
        });
      }
    }

    document.querySelectorAll('[data-slider-section]').forEach((root) => new Slider(root));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snap-panels"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    document.addEventListener('DOMContentLoaded', function () {
      var sections = document.querySelectorAll('.snap-panels');
      if (!sections.length) return;

      var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      sections.forEach(function (section) {
        var panels = Array.from(section.querySelectorAll('.snap-panels__panel'));
        var navItems = Array.from(section.querySelectorAll('[data-snap-panels-nav-item]'));
        var ticking = false;

        if (!panels.length || !navItems.length) return;

        function setActiveNav(index) {
          navItems.forEach(function (item, itemIndex) {
            var isActive = itemIndex === index;
            item.classList.toggle('is-active', isActive);

            if (isActive) {
              item.setAttribute('aria-current', 'true');
            } else {
              item.removeAttribute('aria-current');
            }
          });

          panels.forEach(function (panel, panelIndex) {
            panel.classList.add('is-animate-ready');
            panel.classList.toggle('is-in-view', panelIndex === index);
          });
        }

        function activeIndex() {
          var viewportCenter = window.innerHeight / 2;
          var closestIndex = 0;
          var closestDistance = Number.POSITIVE_INFINITY;

          panels.forEach(function (panel, index) {
            var rect = panel.getBoundingClientRect();
            var panelCenter = rect.top + rect.height / 2;
            var distance = Math.abs(panelCenter - viewportCenter);

            if (distance < closestDistance) {
              closestDistance = distance;
              closestIndex = index;
            }
          });

          return closestIndex;
        }

        function syncActiveNav() {
          setActiveNav(activeIndex());
        }

        navItems.forEach(function (item, index) {
          item.addEventListener('click', function () {
            panels[index].scrollIntoView({
              behavior: prefersReducedMotion ? 'auto' : 'smooth',
              block: 'start',
            });
            setActiveNav(index);
          });
        });

        window.addEventListener('scroll', function () {
          if (ticking) return;

          ticking = true;
          window.requestAnimationFrame(function () {
            syncActiveNav();
            ticking = false;
          });
        });

        window.addEventListener('resize', syncActiveNav);
        syncActiveNav();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
